import classNames from 'classnames';

export interface ErrorMessageProps {
	className?: string;
	id: string;
	children?: React.ReactNode;
}

export const UI_ErrorMessage = ({ className, id, children }: ErrorMessageProps) => (
	<div id={id} className={classNames(className)}>
		{children}
	</div>
);
